var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9302 5.09632L12.4011 19.6254C11.7971 20.2294 10.8178 20.2294 10.2139 19.6254L1.0726 10.4842C0.468638 9.8802 0.468638 8.90096 1.0726 8.297L3.29788 6.07172C3.90184 5.46776 4.88104 5.46776 5.48505 6.07172L11.3075 11.8942L22.5178 0.683928C23.1218 0.0799666 24.1009 0.0799666 24.705 0.683928L26.9302 2.90921C27.5341 3.51317 27.5341 4.49236 26.9302 5.09632Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.c3e8362eb5097a1e504fbec0a4ef30d8.svg";
export { ForwardRef as ReactComponent };